import React, { useState } from 'react';
import api from '../services/api';
import './AdminSetup.css';

function AdminSetup() {
  const [email, setEmail] = useState('');
  const [setupKey, setSetupKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await api.post('/admin/setup', { email, setupKey });
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to setup admin');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container admin-setup-page">
      <div className="page-header">
        <h1>🔐 Admin Setup</h1>
        <p>Promote a user to admin role</p>
      </div>

      <div className="card setup-card">
        <h3>Make User an Admin</h3>
        <p className="setup-note">
          <strong>Setup Key:</strong> alien-setup-2024
        </p>

        {error && (
          <div className="message error">
            ❌ {error}
          </div>
        )}

        {result && (
          <div className="message success">
            ✅ {result.message}
            <br />
            <strong>User:</strong> {result.user.email}
            <br />
            <strong>Role:</strong> {result.user.role}
            <br /><br />
            <strong>Next steps:</strong>
            <ol>
              <li>Log out</li>
              <li>Log back in with the same email</li>
              <li>Access /admin and /admin/purchase</li>
            </ol>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>User Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="customer@example.com"
              required
            />
          </div>

          <div className="input-group">
            <label>Setup Key:</label>
            <input
              type="password"
              value={setupKey}
              onChange={(e) => setSetupKey(e.target.value)}
              placeholder="Enter setup key"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Setting up...' : '🔐 Make Admin'}
          </button>
        </form>
      </div>

      <div className="card instructions-card">
        <h3>📋 How to Use:</h3>
        <ol>
          <li>Register a regular account at <a href="/register">/register</a></li>
          <li>Come to this page (/admin/setup)</li>
          <li>Enter your email and setup key: <code>alien-setup-2024</code></li>
          <li>Click "Make Admin"</li>
          <li>Log out and log back in</li>
          <li>Now you can access:
            <ul>
              <li><a href="/admin">/admin</a> - Admin Dashboard</li>
              <li><a href="/admin/purchase">/admin/purchase</a> - Record Purchases</li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default AdminSetup;
